import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "bootstrap/dist/js/bootstrap.min.js";

import React from "react"; // , { useEffect, useState }
//import { getGenresAsync } from "../services/genres-service";
//import { getBooksAsync } from "../services/books-service";

function Test() {
  /*
  const [setGenresList] = useState([]); //genresList,
  const [setBooksList] = useState([]); //booksList,

  useEffect(() => {
    getGenresAsync()
      .then((response) => {
        console.log("response data db.json", response.data);
        //setGenresList(response.data.map((item) => {
        //  return <li key={item.id}>{item.genre}</li>
        //}))
        setGenresList(
          response.data[0].genres.map((item) => {
            return (
              <div key={item.id} className="container">
                <ul>
                  <li className="container">{item.genre}</li>
                </ul>
              </div>
            );
          })
        );
      })
      .catch((err) =>
        console.log(
          "Something went wrong trying to get the genres from the api.",
          err
        )
      );
  }, [setGenresList]);

  useEffect(() => {
    getBooksAsync()
      .then((response) => {
        console.log("response data books", response.data);
        setBooksList(
          response.data.map((item) => {
            return <li key={item.id}>{item.title}</li>;
          })
        );
      })
      .catch((err) =>
        console.log(
          "Something went wrong trying to get the books from the api.",
          err
        )
      );
  }, [setBooksList]);

  const style = {
    fontSize: '1.375em'
  }
*/

  const style = {
    width: "380px"
  };

  return (
    <>
      <div
        className="d-flex flex-column align-items-stretch flex-shrink-0 bg-white"
        style={style}
      >
        <a
          href="/"
          className="d-flex align-items-center flex-shrink-0 p-3 link-dark text-decoration-none border-bottom"
        >
          <svg className="bi pe-none me-2" width="30" height="24">
            <use xlinkHref="#bootstrap" />
          </svg>
          <span className="fs-5 fw-semibold">List group</span>
        </a>
        <div className="list-group list-group-flush border-bottom scrollarea">
          <a
            href="https://www.telegraaf.nl/"
            className="list-group-item list-group-item-action active py-3 lh-sm"
            aria-current="true"
          >
            <div className="d-flex w-100 align-items-center justify-content-between">
              <strong className="mb-1">List group item heading</strong>
              <small>Wed</small>
            </div>
            <div className="col-10 mb-1 small">
              Some placeholder content in a paragraph below the heading and
              date.
            </div>
          </a>
          <a
            href="https://www.telegraaf.nl/"
            className="list-group-item list-group-item-action py-3 lh-sm"
          >
            <div className="d-flex w-100 align-items-center justify-content-between">
              <strong className="mb-1">List group item heading</strong>
              <small className="text-muted">Tues</small>
            </div>
            <div className="col-10 mb-1 small">
              Some placeholder content in a paragraph below the heading and
              date.
            </div>
          </a>
          <a
            href="https://www.telegraaf.nl/"
            className="list-group-item list-group-item-action py-3 lh-sm"
          >
            <div className="d-flex w-100 align-items-center justify-content-between">
              <strong className="mb-1">List group item heading</strong>
              <small className="text-muted">Mon</small>
            </div>
            <div className="col-10 mb-1 small">
              Some placeholder content in a paragraph below the heading and
              date.
            </div>
          </a>

          <a
            href="https://www.telegraaf.nl/"
            className="list-group-item list-group-item-action py-3 lh-sm"
            aria-current="true"
          >
            <div className="d-flex w-100 align-items-center justify-content-between">
              <strong className="mb-1">List group item heading</strong>
              <small className="text-muted">Wed</small>
            </div>
            <div className="col-10 mb-1 small">
              Some placeholder content in a paragraph below the heading and
              date.
            </div>
          </a>
          <a
            href="https://www.telegraaf.nl/"
            className="list-group-item list-group-item-action py-3 lh-sm"
          >
            <div className="d-flex w-100 align-items-center justify-content-between">
              <strong className="mb-1">List group item heading</strong>
              <small className="text-muted">Tues</small>
            </div>
            <div className="col-10 mb-1 small">
              Some placeholder content in a paragraph below the heading and
              date.
            </div>
          </a>
          <a
            href="https://www.telegraaf.nl/"
            className="list-group-item list-group-item-action py-3 lh-sm"
          >
            <div className="d-flex w-100 align-items-center justify-content-between">
              <strong className="mb-1">List group item heading</strong>
              <small className="text-muted">Mon</small>
            </div>
            <div className="col-10 mb-1 small">
              Some placeholder content in a paragraph below the heading and
              date.
            </div>
          </a>
          <a
            href="https://www.telegraaf.nl/"
            className="list-group-item list-group-item-action py-3 lh-sm"
            aria-current="true"
          >
            <div className="d-flex w-100 align-items-center justify-content-between">
              <strong className="mb-1">List group item heading</strong>
              <small className="text-muted">Wed</small>
            </div>
            <div className="col-10 mb-1 small">
              Some placeholder content in a paragraph below the heading and
              date.
            </div>
          </a>
          <a
            href="https://www.telegraaf.nl/"
            className="list-group-item list-group-item-action py-3 lh-sm"
          >
            <div className="d-flex w-100 align-items-center justify-content-between">
              <strong className="mb-1">List group item heading</strong>
              <small className="text-muted">Tues</small>
            </div>
            <div className="col-10 mb-1 small">
              Some placeholder content in a paragraph below the heading and
              date.
            </div>
          </a>
          <a
            href="https://www.telegraaf.nl/"
            className="list-group-item list-group-item-action py-3 lh-sm"
          >
            <div className="d-flex w-100 align-items-center justify-content-between">
              <strong className="mb-1">List group item heading</strong>
              <small className="text-muted">Mon</small>
            </div>
            <div className="col-10 mb-1 small">
              Some placeholder content in a paragraph below the heading and
              date.
            </div>
          </a>
          <a
            href="https://www.telegraaf.nl/"
            className="list-group-item list-group-item-action py-3 lh-sm"
            aria-current="true"
          >
            <div className="d-flex w-100 align-items-center justify-content-between">
              <strong className="mb-1">List group item heading</strong>
              <small className="text-muted">Wed</small>
            </div>
            <div className="col-10 mb-1 small">
              Some placeholder content in a paragraph below the heading and
              date.
            </div>
          </a>
          <a
            href="https://www.telegraaf.nl/"
            className="list-group-item list-group-item-action py-3 lh-sm"
          >
            <div className="d-flex w-100 align-items-center justify-content-between">
              <strong className="mb-1">List group item heading</strong>
              <small className="text-muted">Tues</small>
            </div>
            <div className="col-10 mb-1 small">
              Some placeholder content in a paragraph below the heading and
              date.
            </div>
          </a>
          <a
            href="https://www.telegraaf.nl/"
            className="list-group-item list-group-item-action py-3 lh-sm"
          >
            <div className="d-flex w-100 align-items-center justify-content-between">
              <strong className="mb-1">List group item heading</strong>
              <small className="text-muted">Mon</small>
            </div>
            <div className="col-10 mb-1 small">
              Some placeholder content in a paragraph below the heading and
              date.
            </div>
          </a>
        </div>
      </div>

      {/*
      <div className="list-group w-auto">
        <label className="list-group-item d-flex gap-3">
          <input
            className="form-check-input flex-shrink-0"
            type="checkbox"
            value=""
            checked
            style={style}
          />
          <span className="pt-1 form-checked-content">
            <strong>Finish sales report</strong>
            <small className="d-block text-muted">
              <svg className="bi me-1" width="1em" height="1em">
                <use xlinkHref="#calendar-event" />
              </svg>
              1:00–2:00pm
            </small>
          </span>
        </label>
        <label className="list-group-item d-flex gap-3">
          <input
            className="form-check-input flex-shrink-0"
            type="checkbox"
            value=""
            style={style}
          />
          <span className="pt-1 form-checked-content">
            <strong>Weekly All Hands</strong>
            <small className="d-block text-muted">
              <svg className="bi me-1" width="1em" height="1em">
                <use xlinkHref="#calendar-event" />
              </svg>
              2:00–2:30pm
            </small>
          </span>
        </label>
        <label className="list-group-item d-flex gap-3">
          <input
            className="form-check-input flex-shrink-0"
            type="checkbox"
            value=""
            style={style}
          />
          <span className="pt-1 form-checked-content">
            <strong>Out of office</strong>
            <small className="d-block text-muted">
              <svg className="bi me-1" width="1em" height="1em">
                <use xlinkHref="#alarm" />
              </svg>
              Tomorrow
            </small>
          </span>
        </label>
        <label className="list-group-item d-flex gap-3 bg-light">
          <input
            className="form-check-input form-check-input-placeholder bg-light flex-shrink-0 pe-none"
            disabled
            type="checkbox"
            value=""
            style={style}
          />
          <span className="pt-1 form-checked-content">
            <span contentEditable="true" className="w-100">
              Add new task...
            </span>
            <small className="d-block text-muted">
              <svg className="bi me-1" width="1em" height="1em">
                <use xlinkHref="#list-check" />
              </svg>
              Choose list...
            </small>
          </span>
        </label>
      </div>
*/}
      {/*
      <div>
        <ul>{genresList}</ul>
      </div>
      <div>
        <ul>{booksList}</ul>
      </div>
*/}
    </>
  );
}

export default Test;
